module.exports = __webpack_public_path__ + "static/media/header-home-biolitoral.f50ae87f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/header-home-biolitoral.png
// module id = 665
// module chunks = 0